import { Navigate, useSearchParams } from 'react-router-dom';
import { readPendingRoomCode, clearPendingRoomCode } from 'lib/pendingRoomCode';

/** Legacy /private hub — redirects to variant lobby private section. */
export default function PrivateRoomsRedirect() {
  const [params] = useSearchParams();
  const variant = params.get('variant') || 'Classic';
  const roomCode = params.get('roomCode') || readPendingRoomCode() || '';
  if (roomCode) clearPendingRoomCode();

  const query = new URLSearchParams();
  query.set('variant', variant);
  query.set('private', '1');
  if (roomCode.trim()) query.set('roomCode', roomCode.trim().toUpperCase());

  return <Navigate to={`/lobby?${query.toString()}`} replace />;
}
